import React from "react";

import { IconDocment } from "fragments/Icons/index";

import Style from "./Style";

export default function index() {
  return (
    <Style>
      <IconDocment />
    </Style>
  );
}
